import { createApiSlice } from 'app/createApiSlice'

export const receivableApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'catatan/piutang',

  endpoints(builder) {
    return {
      postReceivable: builder.mutation({
        query(body) {
          return {
            url: `/api/v1/bussines/receiveable/manual`,
            method: 'POST',
            body,
          }
        },
      }),
      postReceivablePersonal: builder.mutation({
        query(body) {
          return {
            url: `/api/v1/bussines/personal-receiveable-manual`,
            method: 'POST',
            body,
          }
        },
      }),
      postPayReceivable: builder.mutation({
        query(body) {
          return {
            url: `/api/v1/bussines/receivable/pay-manual`,
            method: 'POST',
            body,
          }
        },
      }),
      postPayReceivablePersonal: builder.mutation({
        query(body) {
          return {
            url: `/api/v1/bussines/personal-receiveable-pay-manual`,
            method: 'POST',
            body,
          }
        },
      }),
    }
  },
})

export const { usePostReceivableMutation, usePostPayReceivableMutation, usePostReceivablePersonalMutation, usePostPayReceivablePersonalMutation } =
  receivableApiSlice
